// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"ebb7cdcc","729":"c0756ffa"}[chunkId] + ".css";
};